import { useMemo } from 'react'
import { get } from 'lodash'
import { useSelector } from 'react-redux'
import { CharacterLevel } from '../../utils/constant'

export default function ActionAuth({
  permission = [],
  fallback = null,
  children
}) {
  const { user, permissions } = useSelector((state) => state.account)

  const allow = useMemo(() => {
    if (!permissions) return false
    const operations = get(permissions, [permission[0], 'operations']) || []
    return (
      operations.includes(permission.join('-')) ||
      user.person_character === CharacterLevel.super_admin
    )
  }, [])

  return allow ? children : fallback
}
